export default __webpack_public_path__ + "static/media/Banner_image_Ruimte_small.31b32b91.jpg";